/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BuildingFuture } from './BuildingFuture';
import {
    BuildingFutureFromJSON,
    BuildingFutureFromJSONTyped,
    BuildingFutureToJSON,
    BuildingFutureToJSONTyped,
} from './BuildingFuture';
import type { BuildingOccupancy } from './BuildingOccupancy';
import {
    BuildingOccupancyFromJSON,
    BuildingOccupancyFromJSONTyped,
    BuildingOccupancyToJSON,
    BuildingOccupancyToJSONTyped,
} from './BuildingOccupancy';

/**
 * 
 * @export
 * @interface BuildingCommand
 */
export interface BuildingCommand {
    /**
     * 
     * @type {string}
     * @memberof BuildingCommand
     */
    id?: string | null;
    /**
     * Levels above ground (R+n), ground floor excluded. More than 7 → not eligible.
     * @type {number}
     * @memberof BuildingCommand
     */
    floorsCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BuildingCommand
     */
    basementsCount?: number | null;
    /**
     * Building area in m² (basements count for half — input rule, no back-end computation).
     * @type {number}
     * @memberof BuildingCommand
     */
    area?: number | null;
    /**
     * 
     * @type {BuildingOccupancy}
     * @memberof BuildingCommand
     */
    occupancy?: BuildingOccupancy | null;
    /**
     * Walls block the accesses — expected when occupancy = totally empty (false → not eligible).
     * @type {boolean}
     * @memberof BuildingCommand
     */
    accessWalledUp?: boolean | null;
    /**
     * 
     * @type {BuildingFuture}
     * @memberof BuildingCommand
     */
    future?: BuildingFuture | null;
}



/**
 * Check if a given object implements the BuildingCommand interface.
 */
export function instanceOfBuildingCommand(value: object): value is BuildingCommand {
    return true;
}

export function BuildingCommandFromJSON(json: any): BuildingCommand {
    return BuildingCommandFromJSONTyped(json, false);
}

export function BuildingCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): BuildingCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'floorsCount': json['floorsCount'] == null ? undefined : json['floorsCount'],
        'basementsCount': json['basementsCount'] == null ? undefined : json['basementsCount'],
        'area': json['area'] == null ? undefined : json['area'],
        'occupancy': json['occupancy'] == null ? undefined : BuildingOccupancyFromJSON(json['occupancy']),
        'accessWalledUp': json['accessWalledUp'] == null ? undefined : json['accessWalledUp'],
        'future': json['future'] == null ? undefined : BuildingFutureFromJSON(json['future']),
    };
}

export function BuildingCommandToJSON(json: any): BuildingCommand {
    return BuildingCommandToJSONTyped(json, false);
}

export function BuildingCommandToJSONTyped(value?: BuildingCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'floorsCount': value['floorsCount'],
        'basementsCount': value['basementsCount'],
        'area': value['area'],
        'occupancy': BuildingOccupancyToJSON(value['occupancy']),
        'accessWalledUp': value['accessWalledUp'],
        'future': BuildingFutureToJSON(value['future']),
    };
}

